import React from "react";

interface ColorFieldIconProps {
  className?: string;
}

const ColorFieldIcon: React.FC<ColorFieldIconProps> = ({ className }) => (
  <svg className={className} width="100px" height="100px" viewBox="0 0 100 100">
    <defs>
      <circle id="path-1" cx="50" cy="50" r="50" />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <mask id="mask-2" fill="white">
          <use href="#path-1" />
        </mask>
        <use fill="#FFFFFF" href="#path-1" />
        <rect fill="#EAEAEA" mask="url(#mask-2)" x="75" y="24" width="27" height="27" />
        <rect fill="#EAEAEA" mask="url(#mask-2)" x="21" y="24" width="27" height="27" />
        <rect fill="#EAEAEA" mask="url(#mask-2)" x="48" y="51" width="27" height="27" />
        <rect fill="#EAEAEA" mask="url(#mask-2)" x="48" y="-3" width="27" height="27" />
        <rect fill="#EAEAEA" mask="url(#mask-2)" x="21" y="78" width="27" height="27" />
        <rect fill="#EAEAEA" mask="url(#mask-2)" x="-6" y="-3" width="27" height="27" />
        <rect fill="#EAEAEA" mask="url(#mask-2)" x="75" y="78" width="27" height="27" />
        <rect fill="#EAEAEA" mask="url(#mask-2)" x="-6" y="51" width="27" height="27" />
      </g>
    </g>
  </svg>
);

export default ColorFieldIcon;
